import React, { useContext } from "react";
import Flex from '@react-css/flex';
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import { StyledPartialTsDetalhado } from '../../styled-components/StyledPartialTsDetalhado.style';

export const AcoesTimesheetDetalhes = ({
    openModal,
    openFinalizarModal,
    openTimeSheetHistoricoModal,
    finalizarResumoAccess,
    exportOptions,
    openModalConfigurarPrecoOpen,
    openModalObservacoesOpen,
    possuiPrecificacaoConfigurado,
    openModalConfigurarDescontoOpen,
    openModalMesclarTimseheet,
    openModalEsclarecimento,
    openModalCancelamentoTSOpen,
    openModalReverterTSOpen,
    openModalProbono,
    openFinalizarModalProjetoInterno,
    isFromProjetoInterno
}) => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);

    return (
        <StyledPartialTsDetalhado>
            <div className="timesheet-infs">
                <Flex.Item xs="12" sm="12" md="12">
                    <div className="text-center flex-column-center-mobile">
                        {
                            timesheet?.actions?.cancelarTS && <input className='default-button-red mx-1 mt-2' value='Cancelar TS' type="button" onClick={openModalCancelamentoTSOpen} />
                        }
                        {
                            timesheet?.actions?.revertTS && <input className='default-button-red mx-1 mt-2' value='Reverter TS' type="button" onClick={openModalReverterTSOpen} />
                        }
                        {

                            timesheet?.actions?.acessoDescontoComercial && <input className='default-button-red mx-1 mt-2' value='Desconto' type="button" onClick={openModalConfigurarDescontoOpen} />
                        }
                        {

                            timesheet?.actions?.acessoConfigPreco && !isFromProjetoInterno && <input className='default-button-red mx-1 mt-2' value='Conf. Preço' type="button" onClick={openModalConfigurarPrecoOpen} />
                        }

                        <input className='default-button-red mx-1 mt-2' value='Observações' type="button" onClick={openModalObservacoesOpen} />
                        {
                            possuiPrecificacaoConfigurado && (
                                <>
                                    {
                                        timesheet?.actions?.export && <input className='default-button-red mx-1 mt-2' value='Exportar TS' type="button" onClick={exportOptions} />
                                    }
                                    <button className='default-button-red mx-1 mt-2' onClick={openTimeSheetHistoricoModal}>
                                        {timesheet?.timesheet?.statusTimesheet === 'Reanálise' ?
                                            <span style={{ color: "white" }} className="mr-2 fa-blink">
                                                <svg width={16} fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" /></svg>
                                            </span> : ''}
                                        Histórico
                                    </button>
                                    <input className='default-button-red mx-1 mt-2' value='Resumo' type="button" onClick={openModal} />
                                    {isFromProjetoInterno ? '' : <input className='default-button-red mx-1 mt-2' value='Res. Pro Bono' type="button" onClick={openModalProbono} />}
                                </>
                            )
                        }

                        {
                            timesheet?.actions?.notificacaoEsclarecimento && (
                                <button className='default-button-red mx-1 mt-2' onClick={openModalEsclarecimento}>
                                    <span style={{ color: "white" }} className="mr-2 fa-blink">
                                        <svg width={16} fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" /></svg>
                                    </span>
                                    Esclarecimento
                                </button>
                            )
                        }

                        {
                            timesheet?.actions?.acessoMesclarTS && (
                                <input className='default-button-red mx-1 mt-2' value='Mesclar' type="button" onClick={openModalMesclarTimseheet} />
                            )
                        }

                        {
                            (finalizarResumoAccess?.isEdit || finalizarResumoAccess?.isPlanilhaResumo) && possuiPrecificacaoConfigurado && !isFromProjetoInterno && (
                                <input className='default-button-red mx-1 mt-2' value={finalizarResumoAccess?.isPlanilhaResumo ? 'Planilha Res.' : 'Finalizar'} type="button" onClick={openFinalizarModal} />
                            )
                        }

                        {
                            finalizarResumoAccess?.isEdit && isFromProjetoInterno && (
                                <input className='default-button-red mx-1 mt-2' value={'Finalizar PI'} type="button" onClick={openFinalizarModalProjetoInterno} />
                            )
                        }
                    </div>
                </Flex.Item>
            </div>
        </StyledPartialTsDetalhado>
    );
};
